module.exports = __webpack_public_path__ + "img/plus.6ef3d209.svg";